import { button } from "@storybook/addon-knobs";
import React from "react";

function BigButton(props) {
    const { children, iconName, onClick } = props;
    return (
        <button onClick={onClick} type="button" className="trpr-sf-big-button">
            <i className={`trpr__icon-${iconName}`} />
            <span>{children}</span>
        </button>
    );
}

export default BigButton;
